import { render, staticRenderFns } from "./SectorForm.vue?vue&type=template&id=2487cf5b&scoped=true&"
import script from "./SectorForm.vue?vue&type=script&lang=js&"
export * from "./SectorForm.vue?vue&type=script&lang=js&"
import style0 from "./SectorForm.vue?vue&type=style&index=0&id=2487cf5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2487cf5b",
  null
  
)

export default component.exports